// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vision-breadcrumb-background {
    background: #E0E9F6;
    display: flex;
    width: 100%;
}

.vision-breadcrumb-background .MuiBreadcrumbs-ol {
    height: 40px;
    margin: 0;
    padding: 0 36px;
}

.vision-breadcrumb-background .MuiButton-root {
    padding: 0;
    min-width: 40px;
    text-transform: capitalize;
    height: 20px;
    font-family: Gibson-Regular;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #00172F;
}

.vision-breadcrumb-background .MuiButton-label,
.vision-breadcrumb-background p.MuiTypography-root {
    height: 20px;
    font: normal 400 14px/20px Gibson-Regular;
    text-transform: capitalize;
    margin: 0;
}

.vision-breadcrumb-background .MuiButton-label {
    color: #00172F;
}

.vision-breadcrumb-background p.MuiTypography-root {
    color: #597796;
}

.vision-breadcrumb-background .MuiBreadcrumbs-separator {
    color: #0067A0;
    margin: 0 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,yCAAyC;IACzC,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB","sourcesContent":[".vision-breadcrumb-background {\n    background: #E0E9F6;\n    display: flex;\n    width: 100%;\n}\n\n.vision-breadcrumb-background .MuiBreadcrumbs-ol {\n    height: 40px;\n    margin: 0;\n    padding: 0 36px;\n}\n\n.vision-breadcrumb-background .MuiButton-root {\n    padding: 0;\n    min-width: 40px;\n    text-transform: capitalize;\n    height: 20px;\n    font-family: Gibson-Regular;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #00172F;\n}\n\n.vision-breadcrumb-background .MuiButton-label,\n.vision-breadcrumb-background p.MuiTypography-root {\n    height: 20px;\n    font: normal 400 14px/20px Gibson-Regular;\n    text-transform: capitalize;\n    margin: 0;\n}\n\n.vision-breadcrumb-background .MuiButton-label {\n    color: #00172F;\n}\n\n.vision-breadcrumb-background p.MuiTypography-root {\n    color: #597796;\n}\n\n.vision-breadcrumb-background .MuiBreadcrumbs-separator {\n    color: #0067A0;\n    margin: 0 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
